/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// require('./datetimepicker');

// window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
window.jsPDF = jsPDF;   
window.html2canvas = html2canvas;   
import Echo from 'laravel-echo';
window.Pusher = require('pusher-js');
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true
});
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import moment from 'moment';
import 'daterangepicker/daterangepicker.css';
import 'daterangepicker';
window.moment = moment;
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();
import Chart from 'chart.js/auto';
window.Chart = Chart;
import toastr from 'toastr';
window.toastr = toastr;
import 'toastr/build/toastr.min.css';
require('owl.carousel');
require('owl.carousel/dist/assets/owl.carousel.css');
require('owl.carousel/dist/assets/owl.theme.default.css')
